export const CLEAR_MARKETING_CAMPAIGNS = "clearMarketingCampaigns";
export const SET_MARKETING_CAMPAIGNS = "setMarketingCampaigns";
export const SET_ACTIVE_MARKETING_CAMPAIGN = "setActiveMarketingCampaign";
export const SET_ERRORS = "setErrors";
export const CLEAR_ERRORS = "clearErrors";
export const MANAGE_LOADING_MARKETING_CAMPAIGNS = "manageLoadingMarketingCampaigns";
export const MANAGE_REQUESTING_RESOURCE = "manageRequestingResource";
